module.exports = __webpack_public_path__ + "static/media/question-icon.479215fa.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/question-icon.png
 ** module id = 323
 ** module chunks = 0
 **/